<template>
  <div class="container">
    <el-row class="header_hd">
      <el-col :span="8">
        <a class="logo-box" href="#">
          <img alt="xtyp" class="logo" src="../assets/image/logo.png">
          <img alt="slogn" class="slogn" src="../assets/image/slogn.png">
        </a>
      </el-col>
      <el-col :span="7">
        <el-input placeholder="请输入要搜索的内容" v-model="search" class="xt-select">
          <el-select v-model="searchType" slot="prepend" placeholder="请选择">
            <el-option :label="item.name" v-for="item in options" :key="item.value" :value="item.value"></el-option>
          </el-select>
          <el-button slot="append" type="primary" @click="searchSubmit">搜索</el-button>
        </el-input>
      </el-col>
      <el-col :span="5">
        <div class="qrcode navbar-tools">
          <div class="qrcode-small">
            <img src="../assets/image/Publicnumber.png" alt="">
            <span @click="mousedown()" class="qrcode-title">关注公众号</span>
          </div>
          <div class="qrcode-big" v-if="qrcode">
          <img src="../assets/image/qrcode_shoukuan.jpg" alt="">
          </div>
        </div>
      </el-col>
      <el-col class="login-bar" style="padding:10px 0" :span="4">
        <el-dropdown v-if="loginInfo.id">
          <span class="el-dropdown-link">
            {{loginInfo?loginInfo.nickname2:''}} <i class="el-icon-arrow-down el-icon--right"></i>
          </span>
          <el-dropdown-menu slot="dropdown">
            <el-dropdown-item>
              <router-link :to="{path:'/usercenter/index'}">个人中心</router-link>
            </el-dropdown-item>
            <el-dropdown-item>
              <router-link :to="{path:'/usercenter/order'}">我的订单</router-link>
            </el-dropdown-item>
            <el-dropdown-item divided>
              <div @click="loginOut()">退出登录</div>
            </el-dropdown-item>
          </el-dropdown-menu>
        </el-dropdown>
        <el-button @click="gologin" v-else type="text">登录/注册</el-button>
      </el-col>
    </el-row>
    <el-menu :router="router" :default-active="activeIndex" class="el-menu-xt" mode="horizontal" background-color="#ebebeb" @select="handleSelect" text-color="#333" active-text-color="#fff">
      <el-menu-item v-for="item in menu" :route="item.path" :key="item.index" :index="item.index">{{item.name}}</el-menu-item>
    </el-menu>
  </div>
</template>

<style lang="scss">
$color: #cfa972;
.header_hd {
  padding: 15px 0;
  .el-input-group__append {
    button.el-button {
      background-color: $color;
      color: #fff;
      border-radius: 0px;
    }
  }
  .xt-select {
    .el-input {
      width: 100px;
    }
  }
  .login-bar {
    text-align: right;
    padding: 0 10px;
    .el-button {
      font-size: 15px;
    }
  }
}
</style>
<style scoped lang="scss">
$color: #cfa972;
.container {
  width: 1140px;
  padding: 0;
  margin: 0 auto;
}
.logo-box {
  display: block;
  text-align: left;
  > img {
    display: inline-block;
    vertical-align: middle;
  }
  img.logo {
    margin-right: 20px;
    width: 100px;
    margin-left: 10px;
  }
}
.el-menu-xt {
  > .el-menu-item.is-active {
    background-color: $color !important;
  }
}
.qrcode {
  position: relative;
  height: 100%;
  margin-left: 45px;
  .qrcode-small {
    height: 40px;
    line-height: 40px;
    img {
      vertical-align: middle;
    }
    .qrcode-title {
      font-size: 13px;
      margin-left: 10px;
    }
  }

  .qrcode-big {
    position: absolute;
    top: 45px;
    right: -20px;
    z-index: 999;
  }
}
</style>
<script>
import utils from '../utils/index';
export default {
  name: 'app',
  props: {
    type: {
      type: String,
      default: ""
    },
    keyword: {
      type: String,
      default: ""
    }
  },
  data() {
    return {
      activeIndex: '',
      search: '',
      searchType: "1",
      options: [
        { value: "1", name: "作品" },
        { value: "2", name: "艺术家" },
        { value: "3", name: "资讯" }
      ],
      menu: [
        { name: "首页", path: { path: "/index/index" }, disabled: false, index: "1" },
        { name: "专场拍卖", path: { path: "/auction/index" }, disabled: false, index: "2" },
        { name: "大家拍", path: { path: "/everybody/index" }, disabled: false, index: "3" },
        { name: "最新资讯", path: { path: "/news/index" }, disabled: false, index: "4" },
        { name: "作品征集", path: { path: "/collect/index" }, disabled: false, index: "5" },
        { name: "艺术家", path: { path: "/artist/index" }, disabled: false, index: "6" },
        { name: "关于杏坛", path: { path: "/about/index" }, disabled: false, index: "7" }
      ],
      router: true,
      qrcode: false,
      loginInfo: ""
    }
  },
  components: {

  },
  methods: {
    handleSelect(key, keyPath) {
      console.log(key, keyPath);
    },
    checkRouterLocal(path) {
      // 查找当前路由下标高亮
      //findIndex返回传入一个测试条件（函数）符合条件的数组第一个元素位置。
      let index = this.menu.findIndex(item => item.path.path === path) + 1;
      this.activeIndex = String(index)
    },
    mousedown: function () {
      this.qrcode = !this.qrcode
    },
    gologin() {
      this.$router.push({ path: '/login' })
    },
    loginOut() {
      let _this = this;
      localStorage.removeItem("TOKEN");
      localStorage.removeItem("user");
      localStorage.removeItem("openid");
      localStorage.removeItem("_uuid");
      _this.loginInfo = "";
      _this.$message({
        message: "退出登录成功",
        type: "success"
      });
      //if (_this.$route.path !== "/index/index") {
      _this.$router.replace({
        path: "/index/index"
      }).catch((error) => { error });
      //}
    },
    searchSubmit() {
      let _this = this;
      if (utils.isNull(_this.search)) {
        _this.$message({
          message: "请输入搜索内容",
          type: "error"
        });
        return
      }
      if (utils.isNull(_this.searchType)) {
        _this.$message({
          message: "请选择要的类型",
          type: "error"
        });
        return
      }
      //this.$emit('searchTarget', { keyword: _this.search, type: _this.searchType })
      _this.$router.push({
        path: "/search",
        query: { keyword: encodeURIComponent(_this.search), type: _this.searchType }
      }).catch(error => { error });
    },
    // selectChange(val) {
    //   this.$emit('searchTarget', { keyword: this.search, type: val })
    // }
  },
  created() {

  },
  activated() {

  },
  mounted() {
    let _this = this;
    _this.loginInfo = _this.user;
    // if (_this.$route.path !== "/search") {
    //   _this.searchType = _this.$route.query.type || "1"
    //   _this.searchType = _this.searchType.toString()
    // }
    _this.$emit('searchTarget', { keyword: _this.keyword, type: _this.type })
  },
  watch: {
    "$route"() {
      // 获取当前路径
      let path = this.$route.path;
      // 检索当前路径
      this.checkRouterLocal(path);
      this.qrcode = false
    },
    "keyword": function (newVal) {
      this.search = newVal
    },
    "type": function (newVal) {
      console.log(newVal)
      this.searchType = newVal
    }
  }
}
</script>